<template>
  <div v-if="user.id">
    <ManagerIndex />
  </div>
</template>

<script>
import ManagerIndex from '@/components/hr/manager-index.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    ManagerIndex
  },
  created () {
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  data: function() {
    return { }
  },
}
</script>

